/*
  Mauve Lane · cupom de boas-vindas: aba lateral e a janela que ela abre.
  Marcação em sections/velune-mm-side-tab.liquid; estilos em assets/velune-mm-cupom.css.

  O que faz:
  - a aba abre a janela (<dialog> com showModal: o foco fica preso dentro dela e Esc fecha);
  - fecha pelo X, por Esc, clicando fora e pelo "No, thanks"; ao fechar, o foco volta para a aba;
  - a janela abre sozinha alguns segundos depois de a página carregar, só para quem ainda não a viu;
  - depois do cadastro (a página recarrega), a janela reabre no passo do código;
  - o botão "Copy" copia o código;
  - a aba nunca fica por cima de texto, botão ou campo: a largura dela vem da largura da tela (no CSS);
    o script só troca pela pequena se a página aberta fugir da margem padrão e, onde nem a pequena cabe,
    tira a aba da tela até a pessoa parar num ponto livre.

  O que fica guardado no navegador (sempre dentro de try/catch; sem isso a aba funciona igual):
  - localStorage "mm-cupom" = { e: "fechou" | "cadastrou", t: hora }
      "fechou": já viu; só volta a abrir sozinha depois de 7 dias.
      "cadastrou": nunca mais abre sozinha, e a aba passa a mostrar o código.
  - sessionStorage "mm-cupom-envio" = "1" entre o envio do formulário e a volta da página
      (a loja tem outro cadastro de e-mail no rodapé; isto diz que o envio foi o desta janela).
*/
(function () {
  'use strict';

  var doc = document;
  var root = doc.documentElement;

  var CHAVE = 'mm-cupom';
  var CHAVE_ENVIO = 'mm-cupom-envio';
  var SETE_DIAS = 7 * 24 * 60 * 60 * 1000;
  var ESPERA_SE_OCUPADA = 4000;
  var TENTATIVAS = 6;
  /* A aba e o conteúdo: folga mínima entre os dois (de lado e, com a página parada, acima e abaixo),
     quanto se olha à frente no sentido em que a página rola (é o que deixa a aba sair antes de o
     conteúdo chegar), o tempo parado que conta como "parou de rolar" e quanto mais a página tem de
     ficar parada para a aba voltar (quem só faz uma pausa entre duas roladas não a vê entrar e sair). */
  /* Pedido do Eric em 05/10/2026: "o ícone do desconto de 10% nunca deve sumir, nem quando eu rolar a
     página". Com isto ligado a aba fica sempre à vista: não sai mais de lado quando há texto, botão ou
     campo perto dela (era o que acontecia no celular, a cada rolada). O script ainda escolhe o tamanho.
     Para voltar ao comportamento antigo, pôr false. */
  var SEMPRE_A_VISTA = true;
  var FOLGA = 8;
  var FOLGA_VERTICAL = 8;
  var AVANCO = 40;
  var REPOUSO = 260;
  var VOLTA = 450;
  var CONTROLES = 'button, input, select, textarea, summary, label, [role="button"], [role="radio"], .mm-btn, .button';
  /* páginas em que a janela não abre sozinha (com ou sem o prefixo de idioma, como /en-ca/cart) */
  var SEM_ABRIR = /^\/(?:[a-z]{2}(?:-[a-z0-9]{2,4})?\/)?(?:cart|checkout|checkouts|account|password|challenge)(?:\/|$)/i;

  function ler() {
    try {
      var valor = JSON.parse(window.localStorage.getItem(CHAVE) || 'null');
      return valor && typeof valor === 'object' ? valor : null;
    } catch (error) {
      return null;
    }
  }

  function gravar(estado) {
    try {
      window.localStorage.setItem(CHAVE, JSON.stringify({ e: estado, t: Date.now() }));
    } catch (error) {
      /* sem armazenamento: segue sem lembrar */
    }
  }

  /* Sem conseguir lembrar que a pessoa já viu, a janela abriria sozinha em toda página: melhor não abrir. */
  function consegueLembrar() {
    try {
      var teste = CHAVE + '-teste';
      window.localStorage.setItem(teste, '1');
      window.localStorage.removeItem(teste);
      return true;
    } catch (error) {
      return false;
    }
  }

  function jaViu(memoria) {
    if (!memoria) return false;
    if (memoria.e === 'cadastrou') return true;
    return memoria.e === 'fechou' && Date.now() - Number(memoria.t || 0) < SETE_DIAS;
  }

  function noEditor() {
    return Boolean(window.Shopify && window.Shopify.designMode);
  }

  /* Tem gaveta, janela ou painel aberto, ou a pessoa está digitando? Então não é hora de abrir. */
  function ocupada(janela) {
    if (root.classList.contains('mm-trava')) return true;

    var abertos = [];
    try {
      abertos = doc.querySelectorAll('dialog[open], [popover]:popover-open');
    } catch (error) {
      abertos = doc.querySelectorAll('dialog[open]');
    }
    for (var i = 0; i < abertos.length; i += 1) {
      /* popover "manual" é peça que fica sempre na tela (a barra de prévia da Shopify, avisos): não conta */
      if (abertos[i] !== janela && abertos[i].getAttribute('popover') !== 'manual') return true;
    }

    if (doc.querySelector('#header-group [aria-expanded="true"]')) return true;

    var foco = doc.activeElement;
    if (foco && (/^(INPUT|TEXTAREA|SELECT)$/.test(foco.tagName) || foco.isContentEditable)) return true;

    return false;
  }

  function iniciar() {
    var aba = doc.querySelector('[data-mm-cupom-aba]');
    var janela = doc.querySelector('[data-mm-cupom]');
    if (!aba || !janela || janela.__mmCupom) return;

    var caixa = janela.querySelector('[data-mm-cupom-caixa]');
    var passos = janela.querySelectorAll('[data-mm-cupom-passo]');
    var form = janela.querySelector('form');
    var campo = janela.querySelector('[data-mm-cupom-email]');
    var erro = janela.querySelector('[data-mm-cupom-erro]');
    var frase = janela.querySelector('[data-mm-cupom-frase]');
    var codigo = janela.querySelector('[data-mm-cupom-codigo]');
    var copiar = janela.querySelector('[data-mm-cupom-copiar]');
    var aviso = janela.querySelector('[data-mm-cupom-aviso]');
    var marcador = janela.querySelector('[data-mm-cupom-retorno]');

    var quemAbriu = null;
    var relogio = 0;
    var relogioCopiar = 0;
    var apertouFora = false;

    function mostrar(passo) {
      for (var i = 0; i < passos.length; i += 1) {
        passos[i].hidden = passos[i].getAttribute('data-mm-cupom-passo') !== passo;
      }
      janela.setAttribute('aria-labelledby', passo === 'codigo' ? 'mm-cupom-titulo-codigo' : 'mm-cupom-titulo');
    }

    /* A foto é "lazy": pede antes de a janela aparecer, para ela não surgir em branco. */
    function pedirFoto() {
      var foto = janela.querySelector('img[loading="lazy"]');
      if (foto) foto.loading = 'eager';
    }

    function abrir(origem) {
      if (janela.open) return;
      window.clearTimeout(relogio);
      pedirFoto();
      quemAbriu = origem || doc.activeElement;
      try {
        janela.showModal();
      } catch (error) {
        janela.setAttribute('open', '');
      }
      root.classList.add('mm-cupom-trava');
      aba.setAttribute('aria-expanded', 'true');
      /* o foco vai para a caixa (o leitor de tela anuncia o título) e não para o campo:
         assim o teclado do celular não sobe sozinho */
      if (caixa) {
        try {
          caixa.focus({ preventScroll: true });
        } catch (error) {
          caixa.focus();
        }
      }
    }

    function fechar() {
      if (!janela.open) return;
      if (typeof janela.close === 'function') {
        janela.close();
      } else {
        janela.removeAttribute('open');
        aoFechar();
      }
    }

    function aoFechar() {
      root.classList.remove('mm-cupom-trava');
      aba.setAttribute('aria-expanded', 'false');

      var memoria = ler();
      if (!noEditor() && !(memoria && memoria.e === 'cadastrou')) gravar('fechou');

      var alvo = quemAbriu && quemAbriu !== doc.body && quemAbriu !== root && quemAbriu.isConnected ? quemAbriu : aba;
      quemAbriu = null;
      try {
        alvo.focus({ preventScroll: true });
      } catch (error) {
        /* sem foco: nada a fazer */
      }
      conferirDepois(REPOUSO);
    }

    janela.__mmCupom = { abrir: abrir, fechar: fechar };

    /* ---------------------------------------------------------------- */
    /* A aba nunca por cima de texto, botão ou campo                    */
    /* ---------------------------------------------------------------- */
    var trecho = doc.createRange();
    var recolhida = false;
    var relogioRepouso = 0;
    var ultimaOlhada = 0;
    var ultimaAltura = 0;
    var paginaMedida = '';

    /* Faixa da tela que a aba ocupa quando está à vista, com a folga. Ela sai da tela só de lado,
       então a posição vertical vale mesmo com ela recolhida. Sem aba (tela baixa): null. */
    function zona(acima, abaixo) {
      var largura = aba.offsetHeight;
      var caixa = aba.getBoundingClientRect();
      if (!largura || !caixa.height) return null;
      return { esq: 0, dir: largura + FOLGA, cima: caixa.top - acima, baixo: caixa.bottom + abaixo };
    }

    function cruza(caixa, z) {
      return (
        caixa.width >= 1 &&
        caixa.height >= 1 &&
        caixa.left < z.dir &&
        caixa.right > z.esq &&
        caixa.top < z.baixo &&
        caixa.bottom > z.cima
      );
    }

    /* Botão ou campo conta pela caixa inteira (borda e fundo). O que vai de lado a lado da tela é
       fundo clicável (capa, véu): dele só conta o texto. */
    function controleConta(el, caixa) {
      if (!el.matches(CONTROLES)) return false;
      return !(caixa.left <= 0 && caixa.width >= root.clientWidth * 0.9);
    }

    /* Este elemento põe texto, botão ou campo dentro da faixa? */
    function ocupa(el, z) {
      if (el === aba || aba.contains(el) || el === janela || janela.contains(el)) return false;
      var caixa = el.getBoundingClientRect();
      if (controleConta(el, caixa) && cruza(caixa, z)) return true;
      for (var no = el.firstChild; no; no = no.nextSibling) {
        if (no.nodeType !== 3 || !/\S/.test(no.nodeValue)) continue;
        trecho.selectNodeContents(no);
        var linhas = trecho.getClientRects();
        for (var i = 0; i < linhas.length; i += 1) {
          if (cruza(linhas[i], z)) return true;
        }
      }
      return false;
    }

    /* Pergunta ao navegador o que está desenhado em cada ponto da faixa (só vale o que está à vista ali).
       "completo" olha três colunas, de 6 em 6 px; sem ele, só a borda de fora, de 10 em 10 (enquanto rola). */
    function faixaOcupada(acima, abaixo, completo) {
      var z = zona(acima, abaixo);
      if (!z || typeof doc.elementsFromPoint !== 'function') return false;
      var colunas = completo ? [z.dir - 1, z.dir / 2, 1] : [z.dir - 1];
      var passo = completo ? 6 : 10;
      var fim = Math.min(window.innerHeight - 1, z.baixo);
      var vistos = [];
      for (var c = 0; c < colunas.length; c += 1) {
        for (var y = Math.max(0, z.cima); y <= fim; y += passo) {
          var pilha = doc.elementsFromPoint(colunas[c], y);
          for (var k = 0; k < pilha.length; k += 1) {
            if (vistos.indexOf(pilha[k]) !== -1) continue;
            vistos.push(pilha[k]);
            if (ocupa(pilha[k], z)) return true;
          }
        }
      }
      return false;
    }

    /* Menor distância entre a borda esquerda da tela e um texto, botão ou campo da página inteira.
       Só procura abaixo de "teto" (a largura que a aba quer ocupar): quem está além não atrapalha. */
    function margemLivre(teto) {
      var z = zona(0, 0);
      var menor = teto;

      function conta(el) {
        if (aba.contains(el) || janela.contains(el)) return false;
        if (el.closest('.visually-hidden, [hidden], [inert]')) return false;
        for (var e = el; e && e !== doc.body; e = e.parentElement) {
          var estilo = window.getComputedStyle(e);
          if (estilo.visibility === 'hidden' || estilo.opacity === '0') return false;
          if (estilo.position === 'fixed' || estilo.position === 'sticky') {
            /* peça presa na tela (o topo, a barra de compra): só conta se estiver na altura da aba */
            var presa = e.getBoundingClientRect();
            return Boolean(z) && presa.top < z.baixo && presa.bottom > z.cima;
          }
        }
        return true;
      }

      function olha(caixa, el) {
        /* o que sai pela esquerda da tela (carrossel no meio do caminho) não é margem */
        if (caixa.width < 1 || caixa.height < 1 || caixa.left < 0 || caixa.left >= menor) return;
        if (conta(el)) menor = caixa.left;
      }

      var caminho = doc.createTreeWalker(doc.body, NodeFilter.SHOW_TEXT, null);
      var no;
      while ((no = caminho.nextNode())) {
        if (!/\S/.test(no.nodeValue)) continue;
        var pai = no.parentElement;
        if (!pai) continue;
        var caixaPai = pai.getBoundingClientRect();
        if (caixaPai.left >= menor || caixaPai.right <= 0 || caixaPai.width <= 1 || caixaPai.height <= 1) continue;
        trecho.selectNodeContents(no);
        var linhas = trecho.getClientRects();
        for (var i = 0; i < linhas.length; i += 1) olha(linhas[i], pai);
      }

      var controles = doc.querySelectorAll(CONTROLES);
      for (var j = 0; j < controles.length; j += 1) {
        var caixa = controles[j].getBoundingClientRect();
        if (controleConta(controles[j], caixa)) olha(caixa, controles[j]);
      }
      return menor;
    }

    function larguraDoTamanho(nome) {
      return parseFloat(window.getComputedStyle(aba).getPropertyValue('--aba-' + nome)) || 0;
    }

    /* Confere o tamanho da aba nesta página: vale o da largura da tela (assets/velune-mm-cupom.css), que
       cabe na margem padrão do site em todas as páginas. Só se a página aberta tiver texto, botão ou campo
       mais perto da borda do que isso é que entra a pequena. Até 1179 px só existe a pequena (não há o
       que escolher, e a página nem é medida). */
    function ajustarTamanho() {
      aba.removeAttribute('data-mm-cupom-tam');
      var padrao = aba.offsetHeight;
      var pequena = larguraDoTamanho('p');
      if (!padrao || !pequena || padrao <= pequena) return;
      if (margemLivre(padrao + FOLGA) >= padrao + FOLGA) return;
      aba.setAttribute('data-mm-cupom-tam', 'p');
    }

    /* Muda quando a página cresce ou encolhe (conteúdo que chega depois, filtro aplicado). */
    function retratoDaPagina() {
      var miolo = doc.querySelector('.page-wrapper');
      return [root.clientWidth, root.scrollHeight, miolo ? miolo.scrollHeight : 0].join('x');
    }

    function recolher() {
      if (recolhida) return;
      recolhida = true;
      aba.classList.add('is-recolhida');
    }

    function devolver() {
      if (!recolhida) return;
      recolhida = false;
      aba.classList.remove('is-recolhida');
    }

    /* Página parada: confere o tamanho (se a página mudou) e se o lugar da aba está livre.
       Para sair, basta estar ocupado; para voltar, o lugar tem de continuar livre mais um pouco
       ("podeVoltar" é a segunda conferência, ou a primeira aparição). */
    function conferirAba(podeVoltar) {
      relogioRepouso = 0;
      if (janela.open || !aba.isConnected) return;
      ultimaAltura = alturaRolada();
      var retrato = retratoDaPagina();
      if (retrato !== paginaMedida) {
        paginaMedida = retrato;
        ajustarTamanho();
      }
      if (SEMPRE_A_VISTA) {
        devolver();
        return;
      }
      if (faixaOcupada(FOLGA_VERTICAL, FOLGA_VERTICAL, true)) {
        recolher();
      } else if (recolhida) {
        if (podeVoltar === true) {
          devolver();
        } else {
          relogioRepouso = window.setTimeout(function () {
            conferirAba(true);
          }, VOLTA);
        }
      }
    }

    function conferirDepois(espera) {
      window.clearTimeout(relogioRepouso);
      relogioRepouso = window.setTimeout(conferirAba, espera);
    }

    /* Quanto a página já rolou. Até 989 px quem rola é a janela; de 990 para cima, o .page-wrapper. */
    function alturaRolada() {
      var miolo = doc.querySelector('.page-wrapper');
      return (window.pageYOffset || 0) + (miolo ? miolo.scrollTop : 0);
    }

    /* Rolando (a página ou um carrossel): se vem conteúdo na direção da aba, ela sai antes de ele chegar.
       Olha mais longe só no sentido da rolagem. Só volta com a página parada, para não ficar entrando e saindo. */
    function aoRolar() {
      if (!aba.isConnected) return;
      var agora = Date.now();
      if (!SEMPRE_A_VISTA && !recolhida && agora - ultimaOlhada > 90) {
        var altura = alturaRolada();
        var desce = altura > ultimaAltura;
        var sobe = altura < ultimaAltura;
        ultimaAltura = altura;
        ultimaOlhada = agora;
        /* descendo a página, o conteúdo chega por baixo da aba; subindo, por cima */
        if (faixaOcupada(sobe ? AVANCO : FOLGA_VERTICAL, desce ? AVANCO : FOLGA_VERTICAL, false)) recolher();
      }
      conferirDepois(REPOUSO);
    }

    /* Primeira aparição: já no tamanho e no lugar certos, sem deslizar. */
    function mostrarAba() {
      aba.classList.add('is-parada');
      aba.hidden = false;
      paginaMedida = '';
      ultimaAltura = alturaRolada();
      conferirAba(true);
      window.setTimeout(function () {
        aba.classList.remove('is-parada');
      }, 100);

      doc.addEventListener('scroll', aoRolar, { capture: true, passive: true });
      window.addEventListener('resize', function () {
        paginaMedida = '';
        conferirDepois(200);
      });
      window.addEventListener('load', function () {
        conferirDepois(200);
      });
      /* um toque pode abrir uma sanfona ou aplicar um filtro: confere de novo depois que a página assentar */
      doc.addEventListener(
        'click',
        function () {
          conferirDepois(450);
        },
        true
      );
    }

    /* ---------------------------------------------------------------- */
    /* Abrir e fechar                                                   */
    /* ---------------------------------------------------------------- */
    /* Outros botões da página que abrem a janela (por exemplo, a chamada do cupom na foto da home) */
    doc.addEventListener('click', function (event) {
      var alvo = event.target instanceof Element ? event.target.closest('[data-mm-cupom-abrir]') : null;
      if (!alvo) return;
      event.preventDefault();
      abrir(alvo);
    });

    aba.addEventListener('click', function () {
      abrir(aba);
    });
    ['pointerenter', 'focus', 'touchstart'].forEach(function (nome) {
      aba.addEventListener(nome, pedirFoto, { passive: true, once: true });
    });

    janela.addEventListener('close', aoFechar);

    var fechadores = janela.querySelectorAll('[data-mm-cupom-fechar]');
    for (var f = 0; f < fechadores.length; f += 1) {
      fechadores[f].addEventListener('click', fechar);
    }

    /* Clique fora (no véu) fecha. Só vale se o aperto também começou fora:
       quem seleciona o texto do campo e solta o botão fora da caixa não fecha a janela. */
    janela.addEventListener('pointerdown', function (event) {
      apertouFora = event.target === janela;
    });
    janela.addEventListener('click', function (event) {
      if (event.target !== janela || !apertouFora) return;
      apertouFora = false;
      fechar();
    });

    /* ---------------------------------------------------------------- */
    /* Copiar o código                                                  */
    /* ---------------------------------------------------------------- */
    if (copiar && codigo) {
      var rotulo = copiar.textContent;

      var anunciar = function (texto) {
        if (!aviso) return;
        aviso.textContent = '';
        window.setTimeout(function () {
          aviso.textContent = texto || '';
        }, 30);
      };

      var copiou = function () {
        copiar.textContent = copiar.getAttribute('data-mm-cupom-copiado') || rotulo;
        anunciar(aviso && aviso.getAttribute('data-mm-cupom-aviso-copiado'));
        window.clearTimeout(relogioCopiar);
        relogioCopiar = window.setTimeout(function () {
          copiar.textContent = rotulo;
        }, 2000);
      };

      /* Plano B: seleciona o código (a pessoa copia com o teclado ou com o toque longo) e tenta o comando antigo. */
      var planoB = function () {
        var feito = false;
        try {
          var selecao = window.getSelection();
          var trecho = doc.createRange();
          trecho.selectNodeContents(codigo);
          selecao.removeAllRanges();
          selecao.addRange(trecho);
          feito = Boolean(doc.execCommand && doc.execCommand('copy'));
        } catch (error) {
          feito = false;
        }
        if (feito) {
          copiou();
        } else {
          anunciar(aviso && aviso.getAttribute('data-mm-cupom-aviso-selecionado'));
        }
      };

      copiar.addEventListener('click', function () {
        var texto = (codigo.textContent || '').trim();
        try {
          if (navigator.clipboard && typeof navigator.clipboard.writeText === 'function') {
            navigator.clipboard.writeText(texto).then(copiou, planoB);
          } else {
            planoB();
          }
        } catch (error) {
          planoB();
        }
      });
    }

    /* ---------------------------------------------------------------- */
    /* Volta do cadastro                                                */
    /* ---------------------------------------------------------------- */
    var retorno = marcador ? marcador.getAttribute('data-mm-cupom-retorno') : '';
    var formId = form ? form.id : '';
    var enviou = false;
    try {
      enviou = window.sessionStorage.getItem(CHAVE_ENVIO) === '1';
      if (retorno) window.sessionStorage.removeItem(CHAVE_ENVIO);
    } catch (error) {
      enviou = false;
    }

    if (form) {
      form.addEventListener('submit', function () {
        try {
          window.sessionStorage.setItem(CHAVE_ENVIO, '1');
        } catch (error) {
          /* sem armazenamento: a volta é reconhecida pelo endereço (#id do formulário) */
        }
      });
    }

    /* Tira do endereço o que a Shopify põe depois do cadastro, para a janela não reabrir ao recarregar. */
    function limparEndereco() {
      try {
        var endereco = new URL(window.location.href);
        endereco.searchParams.delete('customer_posted');
        if (endereco.hash === '#' + formId) endereco.hash = '';
        window.history.replaceState(window.history.state, '', endereco.pathname + endereco.search + endereco.hash);
      } catch (error) {
        /* navegador antigo: o endereço fica como está */
      }
    }

    var ancora = window.location.hash.replace('#', '');
    /* O envio foi o desta janela? Vale a marca da sessão, o #id do formulário no endereço ou,
       na volta da página de verificação da Shopify (que perde o #id), o endereço sem âncora nenhuma. */
    var nosso =
      enviou ||
      (formId && ancora === formId) ||
      (retorno === 'ok' && ancora === '' && /[?&]customer_posted=true(?:&|$)/.test(window.location.search));

    var memoriaInicial = ler();
    var mostraCodigo = retorno === 'ok' || retorno === 'repetido' || Boolean(memoriaInicial && memoriaInicial.e === 'cadastrou');

    if (retorno === 'repetido' && frase && frase.getAttribute('data-mm-cupom-frase-repetido')) {
      frase.textContent = frase.getAttribute('data-mm-cupom-frase-repetido');
    }

    mostrar(mostraCodigo ? 'codigo' : 'cadastro');
    /* a aba espera o navegador ficar livre: medir a página no meio da carga atrasaria a primeira pintura */
    if (typeof window.requestIdleCallback === 'function') {
      window.requestIdleCallback(mostrarAba, { timeout: 600 });
    } else {
      window.setTimeout(mostrarAba, 200);
    }

    if (noEditor()) return;

    if (retorno === 'ok' || retorno === 'repetido') {
      gravar('cadastrou');
      if (nosso) {
        abrir(null);
        limparEndereco();
      }
      return;
    }

    if (retorno === 'erro' && nosso) {
      if (erro && erro.textContent.trim()) {
        erro.hidden = false;
        if (campo) {
          campo.setAttribute('aria-invalid', 'true');
          campo.setAttribute('aria-describedby', erro.id);
        }
      }
      abrir(null);
      return;
    }

    /* ---------------------------------------------------------------- */
    /* Abrir sozinha                                                    */
    /* ---------------------------------------------------------------- */
    var segundos = parseFloat(janela.getAttribute('data-mm-cupom-segundos'));
    if (!(segundos > 0)) return;
    if (SEM_ABRIR.test(window.location.pathname)) return;
    if (jaViu(memoriaInicial) || !consegueLembrar()) return;

    var tentativas = 0;

    function tentar() {
      if (janela.open || !janela.isConnected) return;
      /* outra aba do navegador pode ter fechado ou cadastrado nesse meio-tempo */
      if (jaViu(ler())) return;
      /* página em segundo plano (outra aba do navegador na frente): espera a pessoa voltar */
      if (doc.hidden) {
        doc.addEventListener(
          'visibilitychange',
          function () {
            if (!doc.hidden) relogio = window.setTimeout(tentar, 1500);
          },
          { once: true }
        );
        return;
      }
      if (ocupada(janela)) {
        tentativas += 1;
        if (tentativas <= TENTATIVAS) relogio = window.setTimeout(tentar, ESPERA_SE_OCUPADA);
        return;
      }
      /* já conta como vista: se a pessoa mudar de página sem fechar, a janela não volta a abrir sozinha */
      gravar('fechou');
      abrir(null);
    }

    relogio = window.setTimeout(tentar, segundos * 1000);
    /* a foto vem um pouco antes da janela */
    window.setTimeout(pedirFoto, Math.max(0, segundos - 3) * 1000);
  }

  /* Editor de temas: a seção é trocada a cada ajuste; a janela abre quando a seção é escolhida. */
  doc.addEventListener('shopify:section:load', function (event) {
    if (event.target && event.target.querySelector && event.target.querySelector('[data-mm-cupom]')) iniciar();
  });
  doc.addEventListener('shopify:section:select', function (event) {
    var janela = event.target && event.target.querySelector ? event.target.querySelector('[data-mm-cupom]') : null;
    if (janela && janela.__mmCupom) janela.__mmCupom.abrir(null);
  });
  doc.addEventListener('shopify:section:deselect', function (event) {
    var janela = event.target && event.target.querySelector ? event.target.querySelector('[data-mm-cupom]') : null;
    if (janela && janela.__mmCupom) janela.__mmCupom.fechar();
  });

  if (doc.readyState === 'loading') {
    doc.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }
})();
